// extracted by mini-css-extract-plugin
export default {"btn":"SaveBtn_btn__x5kf0"};